export default {
  items: [
    {
      name: '欢迎',
      url: '/welcome',
      icon: 'icon-paper-plane'
    },
    {
      name: '管理员',
      url: '/admin',
      icon: 'icon-user-following',
      admin_type: 'super'
    },
    {
      name: '角色',
      url: '/role',
      icon: 'icon-user-following',
      admin_type: 'super'
    },
    {
      name: '产品',
      url: '/product',
      icon: 'icon-puzzle',
      admin_type: 'qa'
    },
    {
      name: '服务',
      url: '/service',
      icon: 'icon-compass',
      admin_type: 'editor'
    },
    {
      name: '项目',
      url: '/project',
      icon: 'icon-compass',
      admin_type: 'normal'
    },
    {
      name: '数据',
      url: '/stat',
      icon: 'icon-graph',
      admin_type: 'normal'
    },
    {
      name: '点赞中心',
      url: '/vote',
      icon: 'icon-heart',
      admin_type: 'normal'
    },
    {
      name: '欢迎页配置',
      icon: 'icon-settings',
      children: [
        {
          name: '功能分类',
          url: '/settingsWelcome/category',
          admin_type: 'super'
        },
        {
          name: '服务',
          url: '/settingsWelcome/service',
          admin_type: 'editor'
        }
      ],
      admin_type: 'editor'
    },
    {
      name: '联系我们',
      url: '/contact',
      icon: 'icon-paper-plane'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js